import * as React from 'react'

function DragSvg(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={8} height={16} viewBox="0 0 8 16" {...props}>
      <g data-name="Group 53095" transform="translate(-1274 -871)" fill="#d3dade">
        <circle data-name="Ellipse 753" cx={1.5} cy={1.5} r={1.5} transform="translate(1274 871)" />
        <circle data-name="Ellipse 754" cx={1.5} cy={1.5} r={1.5} transform="translate(1279 871)" />
        <circle data-name="Ellipse 755" cx={1.5} cy={1.5} r={1.5} transform="translate(1274 877.5)" />
        <circle data-name="Ellipse 758" cx={1.5} cy={1.5} r={1.5} transform="translate(1274 884)" />
        <circle data-name="Ellipse 756" cx={1.5} cy={1.5} r={1.5} transform="translate(1279 877.5)" />
        <circle data-name="Ellipse 757" cx={1.5} cy={1.5} r={1.5} transform="translate(1279 884)" />
      </g>
    </svg>
  )
}

export default DragSvg
